import { Component } from '@angular/core';

@Component({
    selector: 'pdf-find-next',
    templateUrl: './pdf-find-next.component.html',
    styleUrls: ['./pdf-find-next.component.css'],
    standalone: false
})
export class PdfFindNextComponent {}
